import { Component, ChangeDetectionStrategy } from '@angular/core';
import { BaseService } from '../../services/base.service';

@Component({
  selector: 'app-tab-support-video',
  templateUrl: './tab-support-video.component.html',
  styleUrls: ['./tab-support-video.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TabSupportVideoComponent {
  constructor(public readonly baseService: BaseService) {}
}
